"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectionStatus_ = void 0;
const react_1 = __importDefault(require("react"));
const ws_client_sync_1 = require("@wranggle/ws-client-sync");
const useNetworkState_1 = __importDefault(require("react-use/lib/useNetworkState"));
function useConnectionStatus_(wsClientSync) {
    const { online } = useNetworkState_1.default(); // will prob need to override/stub this for tests
    const [connection, setConnectionState] = react_1.default.useState(_offlineState());
    react_1.default.useEffect(() => {
        if (online !== connection.hasNetworkConnection) {
            setConnectionState(prev => (Object.assign(Object.assign({}, prev), { hasNetworkConnection: online })));
        }
        const updateConnectionState = () => {
            const connState = wsClientSync ? wsClientSync.getWsConnectionState() : ws_client_sync_1.WsConnectionState.Disconnected;
            let res;
            res = {
                hasNetworkConnection: online,
                hasWsConnection: connState === ws_client_sync_1.WsConnectionState.Connected,
                wsConnState: connState,
                allDataBucketsReady: wsClientSync ? wsClientSync.getAllDataBuckets().every(bucket => bucket.isReady()) : false,
            };
            setConnectionState(res);
        };
        if (wsClientSync) {
            wsClientSync.on(ws_client_sync_1.WsClientSyncEvent.ConnectionStateChangeEvent, updateConnectionState);
            wsClientSync.on(ws_client_sync_1.WsClientSyncEvent.JoinStatusChange, updateConnectionState);
            updateConnectionState();
        }
        return () => {
            if (wsClientSync) {
                wsClientSync.off(ws_client_sync_1.WsClientSyncEvent.ConnectionStateChangeEvent, updateConnectionState);
                wsClientSync.off(ws_client_sync_1.WsClientSyncEvent.JoinStatusChange, updateConnectionState);
            }
        };
    }, [wsClientSync, online]);
    return connection;
}
exports.useConnectionStatus_ = useConnectionStatus_;
function _offlineState() {
    return {
        hasNetworkConnection: false,
        hasWsConnection: false,
        allDataBucketsReady: false,
        wsConnState: ws_client_sync_1.WsConnectionState.Disconnected, // provides a bit more info.. mainly WsConnectionState.AttemptingNow
    };
}
//# sourceMappingURL=use-connection-status.js.map